import { render } from "./createShopList.vue?vue&type=template&id=3a33ecd3"
import script from "./createShopList.vue?vue&type=script&lang=js"
export * from "./createShopList.vue?vue&type=script&lang=js"
script.render = render

export default script